import * as React from 'react';
import * as main from '../../../styles/mainOld.module.scss';
import * as learnMore from './learnMore.module.scss';

export const LearnMore = () => {
  return (
    <section className={learnMore.learnMore}>
      <div className={'container'}>
        <div className={learnMore.learnMore__wrapper}>
          <p className={learnMore.learnMore__text}>
            Важно не просто «знать», а уметь самостоятельно учиться и понимать.
            <br />
            Что мешает вашему ребёнку расти как личности?
          </p>
          <a className={main.btn} href={'#learn-more'}>
            Узнать подробности
          </a>
        </div>
      </div>
    </section>
  );
};
